module.exports = __webpack_public_path__ + "static/media/06.52fb4102.mp3";